<template>
    <section :class="theme === 'dark' ? 'tw-bg-[#1a1d21]' : 'tw-bg-slate-50'" class="tw-rounded-2xl tw-shadow-2xl tw-overflow-hidden">
        <div :class="theme === 'dark' ? 'tw-bg-[#1a1d21] tw-border-slate-700' : 'tw-bg-[#e9eef6] tw-border-[#d1d5db]'" class="tw-border-b tw-px-6 tw-py-4 tw-flex tw-items-center tw-gap-3">
            <div :class="theme === 'dark' ? 'tw-bg-cyan-500/10 tw-text-cyan-400' : 'tw-bg-cyan-50 tw-text-cyan-600'" class="tw-p-2.5 tw-rounded-lg">
                <svg class="tw-w-5 tw-h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z"/></svg>
            </div>
            <h3 :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-800'" class="tw-font-bold">Estação Meteorológica</h3>
        </div>
        <div class="tw-p-4 tw-space-y-4">
            <EstacaoDashboard :estacao="estacao.estacao"/>
            <div class="custom-scrollbar tw-w-full tw-overflow-x-auto">
                <table class="tw-w-full tw-text-sm">
                    <thead>
                        <tr :class="theme === 'dark' ? 'tw-border-slate-700' : 'tw-border-slate-200'" class="tw-border-b">
                            <th scope="col" class="tw-px-2 tw-py-3 tw-text-center"></th>
                            <th scope="col" :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-600'" class="tw-px-2 tw-py-3 tw-text-center tw-font-medium tw-text-xs tw-uppercase tw-tracking-wider">Temperatura</th>
                            <th scope="col" :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-600'" class="tw-px-2 tw-py-3 tw-text-center tw-font-medium tw-text-xs tw-uppercase tw-tracking-wider">Umidade</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-600'" class="tw-py-3 tw-text-end tw-flex tw-items-center tw-justify-end tw-gap-1">
                                Máx 
                                <svg class="tw-w-3 tw-h-3" :class="theme === 'dark' ? 'tw-text-orange-400' : 'tw-text-orange-500'" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 15l7-7 7 7"/></svg>
                            </td>
                            <td :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-900'" class="tw-px-2 tw-py-3 tw-text-center tw-font-semibold">{{ estacao.maxMin ? estacao.maxMin.temperatura.max : '0' }}°C</td>
                            <td :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-900'" class="tw-px-2 tw-py-3 tw-text-center tw-font-semibold">{{ estacao.maxMin ? estacao.maxMin.umidade.max : '0' }}%</td>
                        </tr>
                        <tr>
                            <td :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-600'" class="tw-py-3 tw-text-end tw-flex tw-items-center tw-justify-end tw-gap-1">
                                Mín 
                                <svg class="tw-w-3 tw-h-3" :class="theme === 'dark' ? 'tw-text-blue-400' : 'tw-text-blue-500'" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 9l7 7 7-7"/></svg>
                            </td>
                            <td :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-900'" class="tw-px-2 tw-py-3 tw-text-center tw-font-semibold">{{ estacao.maxMin ? estacao.maxMin.temperatura.min : '0' }}°C</td>
                            <td :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-900'" class="tw-px-2 tw-py-3 tw-text-center tw-font-semibold">{{ estacao.maxMin ? estacao.maxMin.umidade.min : '0' }}%</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div :class="theme === 'dark' ? 'tw-text-slate-500' : 'tw-text-slate-600'" class="tw-text-center tw-text-sm">(Informações de Hoje)</div>
        </div>
    </section>
</template>
<script>
import EstacaoDashboard from '@/components/ui/v2/EstacaoDashboard.vue';
import { computed } from 'vue';
import { useStore } from 'vuex';

export default {
    name: 'DashboardEstacao',
    components: {
        EstacaoDashboard
    },
    props: {
        estacao: {
            type: Object,
            default: () => ({
                estacao: {},
                maxMin: {}
            })
        },
    },
    setup() {
        const store = useStore();
        const theme = computed(() => store.state.ui.theme);
        return { theme }
    }    
};
</script>